import { DraftConfiguration, DraftState, SpecialFontTask } from '@/types';
import { isDraftSpecialTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { setSpecialFontTask } from './helper/setSpecialFontTask';

export const setSpecialFontTaskAction =
  (
    { cid }: DraftConfiguration,
    fontId: string,
    align: string,
    text: string,
    task: SpecialFontTask
  ) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (
      isDraftSpecialTextConfiguration(configuration) &&
      configuration.text.style.font.id === fontId &&
      configuration.text.style.textAlign === align &&
      configuration.text.content === text
    ) {
      setSpecialFontTask(configuration, task);
    }
  };
